import axios from "axios";
import { getAPIUrl } from "../config";
import { MEASUREMENT_STATUS } from "../pages/patient-anthropometry/draft-session-utils";

const api = axios.create({
  baseURL: getAPIUrl(),
});

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const measurementService = {
  async listByPatient(patientId) {
    try {
      const response = await api.get("/v1/measurements", {
        headers: authHeaders(),
        params: {
          patient_id: patientId,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao buscar histórico de medidas");
    }
  },

  async create(payload) {
    try {
      const response = await api.post("/v1/measurements", payload, {
        headers: authHeaders(),
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao criar registro de medidas");
    }
  },

  async update(measurementId, payload = {}) {
    try {
      const response = await api.put(`/v1/measurements/${measurementId}`, payload, {
        headers: authHeaders(),
      });

      return response.data;
    } catch (error) {
      throw new Error("Erro ao atualizar registro de medidas");
    }
  },

  async createDraft(payload) {
    return this.create({
      ...payload,
      status: MEASUREMENT_STATUS.DRAFT,
    });
  },

  async finalize(measurementId, payload = {}) {
    return this.update(measurementId, {
      ...payload,
      status: MEASUREMENT_STATUS.COMPLETED,
    });
  },

  async discard(measurementId) {
    return this.delete(measurementId);
  },

  async delete(measurementId) {
    try {
      await api.delete(`/v1/measurements/${measurementId}`, {
        headers: authHeaders(),
      });
    } catch (error) {
      throw new Error("Erro ao excluir registro de medidas");
    }
  },
};

export default measurementService;
